import { TextInput, TextInputProps } from '@mantine/core';
import classes from './Inputs.module.css';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledTextInputProps = TextInputProps & { capabilityFieldId?: string };

const StyledTextInput = ({ capabilityFieldId, ...props }: StyledTextInputProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  return (
    <TextInput
      {...props}
      label={label}
      classNames={{
        input: classes.input,
        label: classes.label,
      }}
    />
  );
};

export default StyledTextInput;
